export const Texts = {
    newEmail: {
        mainHeaderText: 'Email',
        inputLabelText: "Email",
        buttonSaveText: "Save & Verify",
    },
    editEmail: {
        mainHeaderText: 'Edit Email',
        inputLabelText: "Email",
        buttonSaveText: "Update & Verify",
        deleteText: "Delete Email",
    },
    newPhone: {
        mainHeaderText: 'Phone Number',
        inputLabelText: "Phone Number",
        buttonSaveText: "Save & Verify",
    },
    editPhone: {
        mainHeaderText: 'Edit Phone Number',
        inputLabelText: "Phone Number",
        buttonSaveText: "Update & Verify",
        deleteText: "Delete Phone Number",
    }
};
